import styled from 'styled-components'

export const AppBarNotificationWrapper = styled.div`
  background-color: none;
  border-radius: 5px;
  width: 50px;
  height: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
`

export const AppBarNotificationIcon = styled.img``

export const AppBarNotificationText = styled.div`
  font-size: 12px;
  color: white;
  height: 20px;
  width: 20px;
  position: absolute;
  top: 10px;
  margin-left: 25px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  display: flex;
  justify-content: center;
  padding: 2px;
`

export const notificationNumber = styled.span``
